/* eslint-disable @typescript-eslint/no-explicit-any */
export const SETTINGS_UPDATE_PROJECT_DETAILS =
  'SETTINGS_UPDATE_PROJECT_DETAILS';

export type EventHandlerMetadata = {
  key: string;
  data: any;
};

export type EventHubPayload = {
  data: EventHandlerMetadata;
};

export type EventHandlerType = {
  handle: (payload: EventHubPayload, projectId: string) => void;
};
